import { LogLevel } from '../../enums/log-level.enum';

export class LogEntry {
  // Public Properties
  entryDate: string;
  logType: 'info' | 'warn' | 'error' | 'fatal';
  processName: string;
  sourceType: string;
  message;
  loglevel: LogLevel;
  extraInfo: any[];

  constructor(
    message: string,
    logType: 'info' | 'warn' | 'error' | 'fatal',
    extraInfo: any[]
  ) {
    this.message = message;
    this.logType = logType;
    this.extraInfo = extraInfo;
    this.processName = 'ngUI';
    this.sourceType = 'Now.NowAccount.Ng.UI';
    this.entryDate = new Date()
      .toISOString()
      .replace('T', ' ')
      .replace('Z', '');
  }
}
